import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateSchedulingsForQuestionnaireDTO } from '@aphp-ema/common/scheduling/CreateSchedulingsForQuestionnaireDTO';
import { createQuestionnaireScheduling } from './scheduling.api';
import { schedulingQueryKeys } from './queryKeys';
import { HttpError, useNotification } from '@refinedev/core';
import { handleErrorMessages } from '@/shared/utils/errors';

export const useCreateQuestionnaireScheduling = () => {
  const queryClient = useQueryClient();
  const { open: openNotification } = useNotification();

  return useMutation({
    mutationFn: (data: CreateSchedulingsForQuestionnaireDTO) =>
      createQuestionnaireScheduling(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: schedulingQueryKeys.getById(variables.questionnaireId),
      });
    },
    onError: (error: HttpError) => {
      openNotification?.({
        message: handleErrorMessages(error),
        type: 'error',
      });
    },
  });
};
